/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

export const useBenefitLimitedPrices = (params: { versionId: string }) =>
  useQuery({
    queryKey: ['benefits/limited-prices', params.versionId],
    queryFn: () => BenefitsService.getBenefitLimitedPrices(params),
    enabled: !!params.versionId,
  });
